import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'
import { EFIconProps } from './IconProps'

export function BellIcon(iconProps: EFIconProps) {
  const isDark = useAppSelector(isDarkTheme)
  return (
    <svg
      width={iconProps.width}
      height={iconProps.height}
      viewBox={`0 0 ${iconProps.width} ${iconProps.height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.4699 3.15283C23.1624 3.15283 27.8102 7.64325 28.0058 13.3418L28.0117 13.6946V19.4531L29.9514 23.8891C30.0484 24.1111 30.0985 24.3507 30.0985 24.593C30.0985 25.5633 29.3119 26.3499 28.3416 26.3499L21.6866 26.352C21.6866 28.6809 19.7988 30.5687 17.4699 30.5687C15.2243 30.5687 13.3887 28.8133 13.2604 26.5998L13.2526 26.3489L6.61177 26.3499C6.37094 26.3499 6.13269 26.3004 5.9118 26.2045C5.02179 25.8179 4.61369 24.783 5.00027 23.893L6.92821 19.4545V13.6944C6.92905 7.85459 11.6398 3.15283 17.4699 3.15283ZM19.5777 26.3489L15.3616 26.352C15.3616 27.5165 16.3055 28.4604 17.4699 28.4604C18.5659 28.4604 19.4665 27.6242 19.5686 26.5551L19.5777 26.3489ZM17.4699 5.26118C12.8032 5.26118 9.03723 9.02001 9.03656 13.6946V19.8926L7.14751 24.2416H27.8044L25.9033 19.8939L25.9035 13.7126L25.8982 13.3961C25.7421 8.85124 22.0262 5.26118 17.4699 5.26118Z'
        fill={isDark ? 'var(--color-dark-theme)' : 'var(--color-light-theme)'}
      />
    </svg>
  )
}
